import { defineMessages } from 'react-intl-next';

export default defineMessages({
	deleteMessage: {
		id: 'ai-mate.inline-chat-input.warning-view.message',
		defaultMessage: 'Delete response?',
		description:
			'Message displayed when asking user to confirm deleting response generated from AI mate',
	},
	deleteButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.delete-button.label',
		defaultMessage: 'Delete',
		description: 'Label for the delete button',
	},
	keepButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.keep-button.label',
		defaultMessage: 'Keep',
		description: 'Label for the keep button',
	},
	stopMessage: {
		id: 'ai-mate.inline-chat-input.warning-view.stop-message',
		defaultMessage: 'Stop request?',
		description:
			'Message displayed when asking user to confirm stopping the request sent to AI mate',
	},
	yesButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.yes-button.label',
		defaultMessage: 'Yes',
		description: 'Label for the yes button',
	},
	noButtonLabel: {
		id: 'ai-mate.inline-chat-input.warning-view.no-button.label',
		defaultMessage: 'No',
		description: 'Label for the no button',
	},
});
